import React, {} from 'react';

import {
  Transforms
} from 'slate';

import {
  useSlateStatic,
  ReactEditor,
} from 'slate-react';

import HelptapEditor from '../../helpers';

import Placeholder from '../placeholder';

import { ReactComponent as ToggleListItemIcon } from 'assets/images/pages-hidden-indicator-icon.svg';
import { ReactComponent as ToggleListItemOpenedIcon } from 'assets/images/pages-displayed-indicator-icon.svg';

import './index.scss';

function ToggleListHead(props) {

  const element = props.element;

  const editor = useSlateStatic();
  const elementPath = ReactEditor.findPath(editor, element);

  function handleToggleButtonClick(event) {

    event.preventDefault();

    HelptapEditor.toggleListItem.toggleCollapsed(editor, elementPath);
    Transforms.select(editor, elementPath);
    Transforms.collapse(editor, { edge: 'end' });

  }

  function renderToggleButton() {

    const toggleButtonAttributes = {
      className: 'toggle-button',
      onClick: handleToggleButtonClick,
      contentEditable: false
    };

    if (props.element.properties.collapsed === true) {
      return <div {...toggleButtonAttributes}>
        <ToggleListItemIcon />
      </div>;
    }

    return <div {...toggleButtonAttributes}>
      <ToggleListItemOpenedIcon />
    </div>;

  }

  function renderContent() {

    const contentAttributes = {
      className: 'content'
    };

    return <div {...contentAttributes}>
      {<Placeholder element={props.element} placeholder={props.placeholder} />}
      {props.children}
    </div>;

  }

  function renderMain() {

    const attributes = {
      ...props.attributes,
      className: 'toggle-list-head'
    };

    return <div {...attributes}>
      {renderToggleButton()}
      {renderContent()}
    </div>;

  }

  return renderMain();

}

export default ToggleListHead;